class ArticlePopup {
  constructor() {
    this.overlay = document.getElementById("articlePopupOverlay");
    this.modal = document.getElementById("articlePopupModal");
    this.closeBtn = document.getElementById("articlePopupClose");
    this.contentContainer = document.getElementById("articlePopupContent");
    this.headerTitle = document.getElementById("articlePopupHeaderTitle");
    this.container = null;

    this.init();
  }

  init() {
    // Get container element
    this.container = this.modal?.querySelector(".art-popup-container");

    // Add click event to all article cards
    const articleCards = document.querySelectorAll(".cstm-article-card");
    articleCards.forEach((card) => {
      card.addEventListener("click", (e) => {
        e.preventDefault();
        const articleUrl = card.getAttribute("data-article-url");
        this.openPopup(articleUrl);
      });
    });

    // Close popup events
    this.closeBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      this.closePopup();
    });

    // Close when clicking on wrapper (outside container)
    this.modal?.addEventListener("click", (e) => {
      if (e.target === this.modal) {
        this.closePopup();
      }
    });

    // Close when clicking on overlay/backdrop
    this.overlay?.addEventListener("click", () => {
      this.closePopup();
    });

    // Close on ESC key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.modal?.classList.contains("open")) {
        this.closePopup();
      }
    });

    // Show header title on scroll
    this.contentContainer?.addEventListener("scroll", () => {
      if (this.contentContainer.scrollTop > 100) {
        this.headerTitle?.classList.add("show");
      } else {
        this.headerTitle?.classList.remove("show");
      }
    });
  }

  async openPopup(articleUrl) {
    if (!articleUrl) return;

    // Show popup with loader
    document.body.classList.add("js-popup-open");
    this.overlay?.classList.add("open");
    this.modal?.classList.add("open");

    // Show loader
    this.showLoader();

    try {
      // Fetch article content
      const response = await fetch(articleUrl);
      const html = await response.text();

      // Parse the HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Extract article content
      const articleData = this.extractArticleContent(doc);

      // Display content
      this.displayContent(articleData);
    } catch (error) {
      console.error("Error loading article:", error);
      this.displayError();
    }
  }

  extractArticleContent(doc) {
    const data = {
      title: "",
      image: "",
      date: "",
      author: "",
      content: "",
      experienceImage: "",
      experienceReview: "",
      productHandle: "",
      productUrl: "",
    };

    // Try to get the article-template element (Shopify standard)
    const articleTemplate = doc.querySelector("article.article-template");

    if (articleTemplate) {
      // Get title
      const titleEl = articleTemplate.querySelector(
        ".article-template__title, h1"
      );
      if (titleEl) data.title = titleEl.textContent.trim();

      // Get featured image
      const imageEl = articleTemplate.querySelector(
        ".article-template__hero-container img, .featured-image img"
      );
      if (imageEl) data.image = imageEl.src;

      // Get date
      const dateEl = articleTemplate.querySelector("time, .circle-divider");
      if (dateEl) data.date = dateEl.textContent.trim();

      // Get author
      const authorEl = articleTemplate.querySelector(
        ".caption-with-letter-spacing"
      );
      if (authorEl && authorEl.textContent)
        data.author = authorEl.textContent.trim();

      // Get content
      const contentEl = articleTemplate.querySelector(
        ".article-template__content, .rte"
      );
      if (contentEl) {
        const clonedContent = contentEl.cloneNode(true);

        // Remove unwanted elements
        const elementsToRemove = clonedContent.querySelectorAll(
          "button, script, .social-share, .share-button"
        );
        elementsToRemove.forEach((el) => el.remove());

        data.content = clonedContent.innerHTML;
      }

      // Get metafield data from data attributes
      if (articleTemplate.dataset.experienceImage) {
        data.experienceImage = articleTemplate.dataset.experienceImage;
      }
      if (articleTemplate.dataset.experienceReview) {
        data.experienceReview = articleTemplate.dataset.experienceReview;
      }

      // Update header title
      if (this.headerTitle && data.title) {
        this.headerTitle.textContent = data.title;
      }

      return data;
    }

    // Fallback: Try different selectors
    const title = doc.querySelector("h1, .article-title, article header h1");
    if (title) data.title = title.textContent.trim();

    const image = doc.querySelector("article img, .article-image img");
    if (image) data.image = image.src;

    const content = doc.querySelector(
      "article .content, .article-content, .entry-content"
    );
    if (content) {
      const cloned = content.cloneNode(true);
      const elementsToRemove = cloned.querySelectorAll(
        "button, script, .social-share"
      );
      elementsToRemove.forEach((el) => el.remove());
      data.content = cloned.innerHTML;
    }

    return data;
  }

  displayContent(data) {
    let html = '<div class="art-popup-article-wrapper">';

    // Title
    if (data.title && data.title.trim() !== '') {
      html += `<h3 class="art-popup-article-pretitle">Meet the couple</h3>`;
      html += `<h4 class="art-popup-article-title">${data.title}</h4>`;
    }

    // Featured image
    if (data.image) {
      html += `
        <div class="art-popup-article-image">
          <img src="${data.image}" alt="${
        data.title || "Article image"
      }" loading="lazy">
        </div>
      `;
    }

    // Content
    if (data.content && data.content.trim() !== '') {
      html += `<h3 class="art-popup-article-pretitle">Love Story</h3>`;
      html += `<div class="art-popup-article-content">${data.content}</div>`;
    }

    html += "</div>";

    // Experience Review Section
    const hasExperienceReview = data.experienceReview && data.experienceReview.trim() !== '';
    if (data.experienceImage || hasExperienceReview) {
      html += `
        <div class="art-popup-experience-section">
          <div class="art-popup-experience-wrapper">
      `;

      // Experience Image
      if (data.experienceImage) {
        html += `
          <div class="art-popup-experience-image">
            <img src="${data.experienceImage}" alt="Experience Review" loading="lazy">
          </div>
        `;
      }

      // Experience Review Content
      html += `
        <div class="art-popup-experience-content">
          <h6 class="art-popup-experience-title">Monclaire Experience Review</h6>
      `;

      if (hasExperienceReview) {
        html += `
          <div class="art-popup-experience-text">
            <p>"${data.experienceReview}"</p>
          </div>
        `;
      }

      html += `
        </div>
      </div>
    </div>
      `;
    }

    this.contentContainer.innerHTML = html;

    // Scroll to top
    this.contentContainer.scrollTop = 0;
  }

  displayError() {
    this.contentContainer.innerHTML = `
      <div class="art-popup-error">
        <h3>Không thể tải bài viết</h3>
        <p>Vui lòng thử lại sau.</p>
      </div>
    `;
  }

  showLoader() {
    this.contentContainer.innerHTML = `
      <div class="art-popup-loader">
        <div class="art-spinner"></div>
      </div>
    `;
  }

  closePopup() {
    this.modal?.classList.add("closing");
    this.modal?.classList.remove("open");

    // Hide header title
    this.headerTitle?.classList.remove("show");

    setTimeout(() => {
      this.modal?.classList.remove("closing");
      this.overlay?.classList.remove("open");
      document.body.classList.remove("js-popup-open");

      // Clear content after animation
      setTimeout(() => {
        this.contentContainer.innerHTML = "";
        if (this.headerTitle) this.headerTitle.textContent = "";
      }, 100);
    }, 400);
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new ArticlePopup();
  });
} else {
  new ArticlePopup();
}
